import React, { ReactElement } from 'react';
import SinglePageTab from '../../../app/common/single-page-tab/single-page-tab.component';
import SettingsAccountRejectReasonList
  from '../settings-account-reject-reason-list/settings-account-reject-reason-list.component';

const SettingsAccountDealRejectReasons: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isSaving,
    isSaveDisabled,
    isEditMode,
    isRightDrawerOpen,
    accountData,
    dealRejectReasonList,
    formError,
    onCancelForm,
    onSubmitForm,
  } = props;

  const isEmpty: boolean = !accountData.accountDealRejectReasons || !accountData.accountDealRejectReasons.length
    || !dealRejectReasonList || !dealRejectReasonList.length;

  return (
    <SinglePageTab
      isScrollable
      withNoPadding
      isSaving={isSaving}
      isSaveDisabled={isSaveDisabled}
      isEditMode={isEditMode}
      isRightDrawerOpen={isRightDrawerOpen}
      isEmpty={isEmpty}
      formError={formError}
      onCancelForm={onCancelForm}
      onSubmitForm={onSubmitForm}
    >
      <SettingsAccountRejectReasonList
        isEditMode={isEditMode}
        formPrefix="accountDealRejectReasons"
        accountRejectReasonListData={accountData.accountDealRejectReasons}
        rejectReasonList={dealRejectReasonList}
      />
    </SinglePageTab>
  );
});

export default SettingsAccountDealRejectReasons;
